import { createFileRoute } from "@tanstack/react-router";
import Visits from "../../components/Reconcile/Visits";

export const Route = createFileRoute("/reconcile/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Visits />;
}
